<!-- COMMENT OUT large loaders -->
<!-- <div *ngIf="showFormLoader" class="loading-container">
  <app-loader [loaded]="false"></app-loader>
  <div class="loading-text">Loading form data...</div>
</div> -->

<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <div class="addNewTable">
      <!-- Maintenance Owner Table -->
      @if (maintainanceOwner.length > 0) {
<table class="table table-bordered form-inline custom-table">
        <thead>
          <tr>
            <th>PARENT ME CODE</th>
            <th>MAINTENANCE OWNER</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (row of maintainanceOwner; track trackByIndex(i, row); let i = $index) {
<tr>
            <td>
              <div class="ProjectTaggingDropdown">
                <input type="text" 
                       class="form-control numberRecord" 
                       [(ngModel)]="row.PARENT_ME_CODE">
              </div>
            </td>
            <td>
              <div class="ProjectTaggingDropdown">
                <input type="text" 
                       class="form-control numberRecord" 
                       [(ngModel)]="row.MAINTENANCE_OWNER">
              </div>
            </td>
            <td>
              <div class="ProjectTaggingDropdown">
                <button type="button" 
                        (click)="deleteRow(i)" 
                        class="btn btn-xs btn-danger" 
                        style="line-height: 0px;">
                  <span class="fa fa-times"></span>
                </button>
              </div>
            </td>
          </tr>
}
        </tbody>
      </table>
}

    </div>
  </div>
}
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="add-button" 
          type="button" 
          (click)="addNew()" 
          style="float: left;">
    Add Maintenance owner
  </button>
  @if (currentTabName != 'Subsidiary') {
<button
          class="add-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  <button class="button-cancel"
          type="button"
          (click)="cancel()">Cancel</button>
</div>


